import {
	REPORT_ERROR,
	GET_APSAPPOINTEEDATA,
	GET_APSAPPOINTEEDATAEXPORT,
	GET_APSAPPOINTEEDATADETAILS,
	GET_APPOINTEECONTRACTRESPONSEDATA,
	GET_APPOINTEECONTRACTRESPONSEDATAEXPORT,
	GET_APPOINTEECONTRACTRESPONSEDATADETAILS,
	GET_APPOINTEEEXCEPTIONREASON,
	GET_APPOINTEEEXCEPTIONREASONEXPORT,
	GET_APPOINTEEEXCEPTIONREASONDETAILS
} from '../Enums/Appointee.Contract.Enums';

const initState = {
	appointees: JSON.parse(sessionStorage.getItem('Appointees')) || [],
	appointeeData: [],
	appointeeDataExport: [],
	appointeeDataDetails: [],
	apiCallCompleted: false,
	errorMessage: ''
};

const appointeeReducer = (state = initState, action) => {
	let updatedState = {};

	switch (action.type) {
		case 'SEARCH_BY_UNIQUE_PARAM':
			updatedState = {
				...state,
				errorMessage: '',
				appointees: [action.payload.appointee, ...state.appointees.filter(element => element.AppointeeId !== action.payload.appointee.AppointeeId)]
			};
			sessionStorage.setItem('Appointees', JSON.stringify(updatedState.appointees));
			return updatedState;
		case 'SEARCH_BY_NAME_DOB':
			let arr = [...action.payload.appointees, ...state.appointees];
			updatedState = {
				...state,
				errorMessage: '',
				appointees: arr.filter((obj, i, self) => i === self.findIndex(o => o.AppointeeId === obj.AppointeeId))
			};
			return updatedState;
		case 'REMOVE_APPOINTEE':
			updatedState = {
				...state,
				errorMessage: '',
				appointees: state.appointees.filter(element => element.AppointeeId !== action.payload.appointeeId) //Remove Element By appointee ID
			};
			sessionStorage.setItem('Appointees', JSON.stringify(updatedState.appointees));
			return updatedState;
		case 'SEARCH_FAILED':
			return {
				...state,
				errorMessage: action.payload.errorMessage || 'An Error Occured'
			};
		case GET_APSAPPOINTEEDATA:
			updatedState = {
				...state,
				appointeeData: action.payload.data,
				apiCallCompleted: true,
				errorMessage: action.payload.data.errors
			};
			return updatedState;
		case GET_APSAPPOINTEEDATAEXPORT:
			updatedState = {
				...state,
				appointeeDataExport: action.payload.data,
				apiCallCompleted: true,
				errorMessage: action.payload.data.errors
			};
			return updatedState;
		case GET_APSAPPOINTEEDATADETAILS:
			updatedState = {
				...state,
				appointeeDataDetails: action.payload.data,
				apiCallCompleted: true,
				errorMessage: action.payload.data.errors
			};
			return updatedState;
		case GET_APPOINTEECONTRACTRESPONSEDATA:
			updatedState = {
				...state,
				appointeeData: action.payload.data,
				apiCallCompleted: true,
				errorMessage: action.payload.data.errors
			};
			return updatedState;
		case GET_APPOINTEECONTRACTRESPONSEDATAEXPORT:
			updatedState = {
				...state,
				appointeeDataExport: action.payload.data,
				apiCallCompleted: true,
				errorMessage: action.payload.data.errors
			};
			return updatedState;
		case GET_APPOINTEECONTRACTRESPONSEDATADETAILS:
			updatedState = {
				...state,
				appointeeDataDetails: action.payload.data,
				apiCallCompleted: true,
				errorMessage: action.payload.data.errors
			};
			return updatedState;
		case GET_APPOINTEEEXCEPTIONREASON:
			updatedState = {
				...state,
				appointeeData: action.payload.data,
				apiCallCompleted: true,
				errorMessage: action.payload.data.errors
			};
			return updatedState;
		case GET_APPOINTEEEXCEPTIONREASONEXPORT:
			updatedState = {
				...state,
				appointeeDataExport: action.payload.data,
				apiCallCompleted: true,
				errorMessage: action.payload.data.errors
			};
			return updatedState;
		case GET_APPOINTEEEXCEPTIONREASONDETAILS:
			updatedState = {
				...state,
				appointeeDataDetails: action.payload.data,
				apiCallCompleted: true,
				errorMessage: action.payload.data.errors
			};
			return updatedState;
		case REPORT_ERROR:
			updatedState = {
				...state,
				errorMessage: action.payload.errorMessage,
				apiCallCompleted: true
			};
			return updatedState;
		default:
			return state;
	}
};

export default appointeeReducer;
